/** HH:mm from a Postgres TIME ('09:00:00'). */
export function hhmm(value: string | null | undefined): string {
  return value ? value.slice(0, 5) : '';
}
